var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('b-col',[_c('NumberSeprator',{model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})],1),_c('b-col',[_vm._v(_vm._s(_vm.number))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }